import React from 'react';
import { bool, string, func, number } from 'prop-types';
import { CardActions, Button } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { showBelowSmBreakpoint } from '../../constants/responsiveClassNames';
import QuotesTabsView from './QuotesTabsView';
import QuotesNoTabsView from './QuotesNoTabsView';
import QuotesFallbackView from './QuotesFallbackView';
import { quotesPropType } from '../../utils/propTypes';

const QuotesActions = () => (
  <div className={classNames(showBelowSmBreakpoint, 'sui-mt-auto')}>
    <CardActions>
      <Button fullWidth href="/quote/list">View All Quotes</Button>
    </CardActions>
  </div>
);

const QuotesContent = ({
  activeQuotes,
  containerWidth,
  expiredQuotes,
  hasQuotes,
  maxListSize,
  quotes,
  selectedTab,
  setSelectedTab,
  showTabs,
}) => {
  if (!hasQuotes) return <QuotesFallbackView />;
  return (
    <div
      className="sui-flex sui-flex-col sui-justify-start sui-grow"
    >
      {showTabs ? (
        <QuotesTabsView
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          containerWidth={containerWidth}
          activeQuotes={activeQuotes}
          expiredQuotes={expiredQuotes}
          maxListSize={maxListSize}
        />
      ) : (
        <QuotesNoTabsView quotes={quotes} maxListSize={maxListSize} />
      )}
      <QuotesActions />
    </div>
  );
};

QuotesContent.propTypes = {
  activeQuotes: quotesPropType.isRequired,
  containerWidth: number,
  expiredQuotes: quotesPropType.isRequired,
  hasQuotes: bool.isRequired,
  quotes: quotesPropType.isRequired,
  selectedTab: string.isRequired,
  setSelectedTab: func.isRequired,
  showTabs: bool.isRequired,
  maxListSize: number,
};

QuotesContent.defaultProps = {
  containerWidth: undefined,
  maxListSize: 3
};

export default QuotesContent;